import { cn } from '@/shared/helpers/classnames'

import { type FC } from 'react'

import { Root as RadixSeparator } from '@radix-ui/react-separator'

import type { SeparatorProps } from './types'

/**
 * Separator component
 * A visual or semantic separator between content sections
 */
export const Separator: FC<SeparatorProps> = ({
  variant = 'default',
  orientation = 'horizontal',
  decorative = true,
}) => {
  return (
    <RadixSeparator
      orientation={orientation}
      decorative={decorative}
      className={cn(
        'separator',
        'bg-base-content/10',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
      )}
      data-variant={variant}
    />
  )
}
